import React from "react";

const TableSkeleton = ({ columns = 9, rows = 5, isFirstColSticky = false }) => {
  return (
    <div className="table-responsive-k">
      <table className="custom-table-k">
        <thead className="table-header">
          <tr className="dark-bg-k">
            {Array.from({ length: columns }).map((_, index) => (
              <th
                key={index}
                className={
                  index === 0 && isFirstColSticky ? "sticky-column" : ""
                }
              >
                <div
                  className="skeleton-header"
                  style={{
                    height: "20px",
                    background:
                      "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                    backgroundSize: "200% 100%",
                    animation: "skeleton-loading 1.5s infinite",
                    borderRadius: "4px",
                    width: "80%",
                  }}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="table-body">
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td
                  key={colIndex}
                  className={
                    colIndex === 0 && isFirstColSticky ? "sticky-column" : ""
                  }
                >
                  <div
                    className="skeleton-cell"
                    style={{
                      height: "16px",
                      background:
                        "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                      backgroundSize: "200% 100%",
                      animation: "skeleton-loading 1.5s infinite",
                      borderRadius: "4px",
                      width: colIndex === 0 ? "90%" : "60%",
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;